import { Modal, ModalProps } from '@/modules/common/components/Modal';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';

export type DeactivateLearningBudgetConfirmationModalProps = Omit<
  ModalProps,
  'title' | 'subTitle' | 'onClose'
> & {
  open: boolean;
  onClose: ({ confirmed }: { confirmed: boolean }) => Promise<void>;
};

export function DeactivateLearningBudgetConfirmationModal({
  open,
  onClose,
  ...props
}: DeactivateLearningBudgetConfirmationModalProps) {
  const {
    formState: { isSubmitting, isValid },
    control,
    handleSubmit,
  } = useForm({
    defaultValues: {
      confirmed: false,
    },
    resolver: yupResolver(
      yup.object({
        confirmed: yup
          .boolean()
          .oneOf(
            [true],
            'Please confirm to deactivate the Learning Budget feature',
          )
          .required(),
      }),
    ),
  });

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose({ confirmed: false });
      }}
      title="Are you sure you want to deactivate the Learning Budget feature?"
      subTitle={
        <Typography variant="body1" color="text.secondary">
          Disabling this feature will prevent employees from requesting or using
          their learning budget. You can re-enable it at any time.
        </Typography>
      }
      actions={
        <>
          <Button
            variant="outlined"
            type="button"
            form="deactivate-learning-budget-confirmation-modal"
            onClick={() => {
              onClose({ confirmed: false });
            }}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={!isValid}
            loading={isSubmitting}
            form="deactivate-learning-budget-confirmation-modal"
          >
            Confirm
          </Button>
        </>
      }
      classes={{ paper: 'max-w-2xl' }}
      {...props}
    >
      <form
        id="deactivate-learning-budget-confirmation-modal"
        className="py-2"
        onSubmit={e => {
          handleSubmit(onClose)(e);
        }}
      >
        <FormControlLabel
          control={
            <Controller
              control={control}
              name="confirmed"
              render={({ field }) => <Checkbox {...field} />}
            />
          }
          label="Yes, I want to deactivate the Learning Budget feature"
        />
      </form>
    </Modal>
  );
}
